<div class="replay-balloon-header">
  <div class="replay-balloon-header__info">
    <div *ngIf="titleText"
      class="replay-balloon-header__info__title">
      <mat-icon [svgIcon]="statusIcon"
        class="vehicle-status-item__vehicle-body-icon mat-icon-size-special"></mat-icon>
      <span class="replay-balloon-header__info__title__text">{{ titleText }}
        <ng-content select="[title-content]"></ng-content>
      </span>
    </div>
    <ng-content select="[subtitle-content]"></ng-content>
  </div>
</div>
